/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import type { GfaLocaleServiceV1 } from '@volkswagen-onehub/gfa-locale-service';
import type { GfaServiceConfigProviderV1 } from '@volkswagen-onehub/gfa-service-config-provider';

import { FALLBACK_LANGUAGE } from '../types';
import type { FeatureAppState, I18nTranslations } from '../types';
import { fetchI18nMessages } from './i18n';
import { debug } from './debugging';
import { getSearchParamValue } from './getSearchParamValue';

let translations: I18nTranslations;
let fallbackTranslations: I18nTranslations;

export async function createInitialState(
  localeService: GfaLocaleServiceV1,
  serviceConfigProvider: GfaServiceConfigProviderV1,
): Promise<FeatureAppState> {
  const primaryLanguage = localeService.language;
  const fallbackLanguage = localeService.language !== FALLBACK_LANGUAGE ? FALLBACK_LANGUAGE : '';
  const redirectTagPath = getSearchParamValue('redirectTagPath');

  if (!translations) {
    if (!redirectTagPath) {
      debug('not loading any i18n as no notification will show up');
    } else {
      const i18nApiConfig = serviceConfigProvider?.gfa?.i18n;

      if (i18nApiConfig) {
        translations = await fetchI18nMessages(i18nApiConfig, primaryLanguage);

        if (fallbackLanguage) {
          fallbackTranslations = await fetchI18nMessages(i18nApiConfig, fallbackLanguage);

          if (!fallbackTranslations || i18nApiConfig.path?.indexOf('i18n.json') !== -1) {
            // if fallback translations are not set or FA is run in static demo integrator
            fallbackTranslations = {
              otherSitesLinkCaption: 'other country websites',
              noticeText:
                'You are at {{countrySite}}. The page content is also available on {{otherSitesLink}}.',
            };
          }
        }
      } else {
        debug(`createInitialState(): GFA service-config-provider: 'i18n' config not found!`);
      }
    }
  }

  return {
    primaryLanguage: translations ? primaryLanguage : '',
    fallbackLanguage: fallbackTranslations ? fallbackLanguage : '',
    translations,
    fallbackTranslations,
    redirectTagPath,
  };
}
